import React, {useEffect, useState} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Pagination } from "../../../../component/paging";
import { Page } from "../../../../interface/model/page";
import { FaqInfoDTO, createFaqInfoDTO } from '../../../../interface/model/board';
import { makeStyles } from '@material-ui/core/styles';


import TableContainer from '@material-ui/core/TableContainer';
import Api from "../../../../interface/api/content"
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";
import Paper from "@material-ui/core/Paper";


export default function Faq() {
    const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
    const initBoardInfo = {...createFaqInfoDTO, siteInfoSeq : siteInfo.seq};
    const [ selectedFaqInfo, setSelectedFaqInfo ] = useState<FaqInfoDTO>(null);
    const [ faqInfos, setFaqInfos ] = useState<Page>();

    const [ pageNumber, setPageNumber ] = useState<number>(0);
    const [ searchInfo , setSearchInfo ] = useState({
        boardSearchType : 'all',
        searchValue : ''
    });

    function modeHandler(boardInfo) {
        setSelectedFaqInfo(boardInfo);
    }

    function insertHandler() {
        if( selectedFaqInfo.seq !== null ) Api.updateBoardInfo(selectedFaqInfo);
        else Api.createBoardInfo(selectedFaqInfo);

        alert('정상적으로 처리되었습니다.');
        Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => {
            setSelectedFaqInfo(null);
            setFaqInfos(res.data)
        });
        //Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => setFaqInfos(res.data));
    }

    function modifyHandler(boardInfo) {
        setSelectedFaqInfo(boardInfo);
    }

    function deleteHandler(seq) {
        Api.deleteBoardInfo(seq).then(res => {
            alert('정상적으로 처리되었습니다.');
            Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => setFaqInfos(res.data));
        });
    }


    return (
        <div className="nv_contents">
            {
                selectedFaqInfo !== null ?
                    <>
                        <Insert selectedFaqInfo={selectedFaqInfo}
                                setSelectedFaqInfo={setSelectedFaqInfo} />
                        <div className="btn_area nv_page_bottomarea_type2">
                            <button type="button" className="nv_green_button m_w_100" style={{marginLeft:'5px'}} onClick={() => modeHandler(null)}>취소</button>
                            <button type="submit" className="nv_blue_button m_w_100" onClick={insertHandler}>저장</button>
                        </div>
                    </> :
                    <>
                        <List siteInfo = { siteInfo }
                              faqInfos = { faqInfos }
                              setFaqInfos = { setFaqInfos }
                              searchInfo = { searchInfo }
                              setSearchInfo = { setSearchInfo }
                              pageNumber = { pageNumber }
                              modifyHandler = { modifyHandler }
                              deleteHandler = { deleteHandler } />
                        <div className="nv_table_box nv_m_btn_area nv_bord_btn_area">
                            <button type="button" className="nv_blue_button right" onClick={() => modeHandler(initBoardInfo)}>작성</button>
                        </div>
                    </>
            }
        </div>
    )
}

function List({siteInfo, faqInfos, setFaqInfos, searchInfo, setSearchInfo, pageNumber, modifyHandler, deleteHandler}) {

    const useRowStyles = makeStyles({
        root: {
            '& > *': {
                borderBottom: '1px solid #e1e1e1',
            },
        },
    });
    const classes = useRowStyles();

    function searchHandler() {
        if(searchInfo.searchValue !== '') {
            const siteInfo = JSON.parse(localStorage.getItem('siteInfo'));
            Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => setFaqInfos(res.data));
        }
    }

    function pageMoveHandler(pageNumber) {
        Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => setFaqInfos(res.data));
    }

    function submit(e) {
        e.preventDefault();
        searchHandler();
    }

    useEffect(() => {
        Api.getBoardInfosBySearchAndPage("FAQ", siteInfo.seq, searchInfo, pageNumber).then(res => {
            setFaqInfos(res.data)
        });
    }, [])

    return(
        <>
            <form onSubmit={submit}>
                <div className="nv_contents_search">
                    <div className="nv_select_box">
                        <p id="conditionKey">
                            {searchInfo.boardSearchType == 'all' && '전체'}
                            {searchInfo.boardSearchType == 'title' && '제목'}
                            {searchInfo.boardSearchType == 'contents' && '내용'}
                        </p>
                        <ul>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'all'})}>전체</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'title'})}>제목</li>
                            <li onClick={() => setSearchInfo({...searchInfo, boardSearchType: 'contents'})}>내용</li>
                        </ul>
                    </div>
                    <div className="nv_search_box">
                        <input type="text" className="nv_input" id="conditionValue" title="Search" onChange={(e) => setSearchInfo({...searchInfo, searchValue: e.target.value})}/>
                        <input type="submit" className="nv_search_icon tpc_skip m_skip" title="search"/>
                    </div>
                    <div className="nv_search_box pc_skip tpc_skip" style={{width:"32px;"}}>
                        <input type="submit" className="nv_search_icon" title="search"/>
                    </div>
                </div>
            </form>
            <div className="nv_table_box">
                <TableContainer component={Paper}>
                    <table className="nv_table textcenter nv_board_table" id="faqTable">
                        <colgroup>
                            <col style={{width:'85%'}} />
                            <col style={{width:'15%'}} />
                        </colgroup>
                        <thead>
                        <tr>
                            <th scope="row">제목</th>
                            <th scope="row">관리</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            faqInfos !== undefined && faqInfos.content.length > 0
                            ?
                                faqInfos.content.map((faqInfo, index) => (
                                    <tr key={`faqInfoKey-${index}`}>
                                        <td>{faqInfo.title}</td>
                                        <td>
                                            <ManagementMenuOptionItem items={[
                                                {
                                                    innerHTML:'수정',
                                                    onClickHandler:() => modifyHandler(faqInfo)
                                                },
                                                {
                                                    innerHTML:'삭제',
                                                    onClickHandler:() => deleteHandler(faqInfo.seq)
                                                }
                                            ]}/>
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr>
                                    <td colSpan={2}>등록된 FAQ가 존재하지 않습니다.</td>
                                </tr>
                        }
                        </tbody>
                    </table>
                </TableContainer>
                <div className="nv_table_pagenum" id="pagenation">
                    <Pagination page={ faqInfos } pageMoveHandler={ pageMoveHandler } />
                </div>
            </div>
        </>
    )
}

function Insert({selectedFaqInfo, setSelectedFaqInfo}) {

    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic', 'underline','strike', 'blockquote'],
          [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
          ['link', 'image'],
          [{ 'align': [] }, { 'color': [] }, { 'background': [] }],
          ['clean']
        ],
      }
    
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image',
        'align', 'color', 'background',        
      ]

    return(
        <>
            <div className="nv_table_tit nv_wirte_tit">
                <h4>FAQ 작성</h4>
                <p><span className="nv_red">*</span> 는 필수 입력 사항입니다.</p>
            </div>
            <table className="nv_table nv_write_table">
                <colgroup>
                    <col width={'20%'}/>
                    <col/>
                </colgroup>
                <tbody>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>제목</td>
                        <td>
                            {
                                selectedFaqInfo.title != null ?
                                <input type="text"
                                        className="nv_input"
                                        name="title"
                                        value={selectedFaqInfo.title}
                                        onChange={(e) => setSelectedFaqInfo({...selectedFaqInfo, title: e.target.value})}
                                /> :
                                <input type="text"
                                        className="nv_input"
                                        name="title"
                                        placeholder="제목을 입력해주세요."
                                        onChange={(e) => setSelectedFaqInfo({...selectedFaqInfo, title: e.target.value})}
                                />
                            }
                        </td>
                    </tr>
                    <tr>
                        <td className="nv_bold textcenter"><span className="nv_red">*</span>내용</td>
                        <td>
                            <ReactQuill style={{width: '100%', height: "350px", overflow:'auto', listStyle:'none'}}
                                modules={modules}
                                formats={formats}
                                value={selectedFaqInfo.contents || ''}
                                onChange={(content, delta, source, editor) => setSelectedFaqInfo({...selectedFaqInfo, contents : editor.getHTML()})} 
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}